import catalog from "./mediaCatalog.json";

export const SITE = "https://www.mag-automate.com";

export function absoluteMediaUrl(path) {
  if (!path) return SITE;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE}${encodeURI(path)}`;
}

function pageUrl(path) {
  return path === "/" ? `${SITE}/` : `${SITE}${path}`;
}

export function mediaForPath(path) {
  return catalog.pages[path] || { images: [], videos: [] };
}

export function videoJsonLdForPath(path) {
  const { videos = [] } = mediaForPath(path);
  return videos.map((video) => ({
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: video.name,
    description: video.description,
    thumbnailUrl: absoluteMediaUrl(video.thumbnail),
    uploadDate: video.uploadDate,
    duration: video.duration,
    contentUrl: absoluteMediaUrl(video.content),
    url: pageUrl(path),
    publisher: { "@id": `${SITE}/#organization` },
  }));
}

export function imageJsonLdForPath(path) {
  const { images = [] } = mediaForPath(path);
  return images.map((image) => ({
    "@context": "https://schema.org",
    "@type": "ImageObject",
    contentUrl: absoluteMediaUrl(image.loc),
    url: absoluteMediaUrl(image.loc),
    name: image.title,
    caption: image.title,
  }));
}

export function jsonLdWithMedia(path, ...blocks) {
  return [...blocks, ...imageJsonLdForPath(path), ...videoJsonLdForPath(path)];
}
